import React from "react";

const DeclineInvitationModal = ({
  isOpen,
  onClose,
  onDecline,
  buyerName,
  itemName,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-[12px] p-5 md:p-8 max-w-[625px] w-full mx-4">
        {/* Header */}
        <h3 className="text-page-title md:text-page-title-d font-rubik text-gray-[#1E1E1E] mb-4">
          Decline invitation
        </h3>

        {/* Content */}
        <div className="mb-8 text-page-subtitle-d font-normal opacity-50">
          <p className="text-[#1E1E1E] mb-4 leading-relaxed">
            Are you sure you want to decline{" "}
            <span className="">{buyerName}</span>'s request for{" "}
            <span className="">{itemName}</span>?
          </p>
          <p className="text-[#1E1E1E]">This action cannot be undone.</p>
        </div>

        {/* Actions */}
        <div className="flex flex-col md:flex-row gap-4 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-3 order-2 md:order-1 text-esblue min-w-[147px] rounded-[8px] bg-[#F5F8FF]"
          >
            Cancel
          </button>
          <button
            onClick={onDecline}
            className="px-4 py-2 order-1 md:order-2 bg-[#FFD9D9] min-w-[147px] text-[#FF6E6E] text-nav-d rounded-[8px]"
          >
            Decline invitation
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeclineInvitationModal;
